import React, { useState } from 'react'
import { Card } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import SendIcon from '@mui/icons-material/Send'

type QRCodeJsonUploadCardProps = {
  disable: boolean
  handleJsonPayloadUpload: (jsonPayload: string) => void
}

const QRCodeJsonUploadCard = ({
  disable,
  handleJsonPayloadUpload,
}: QRCodeJsonUploadCardProps): JSX.Element => {
  const { t } = useTranslation()
  const [textAreaContent, setTextAreaContent] = useState<string>('')

  const handleTextAreaChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ): void => {
    setTextAreaContent(event.target.value)
  }

  const handleSubmit = (): void => {
    handleJsonPayloadUpload(textAreaContent)
    setTextAreaContent('')
  }

  return (
    <Card style={CardStyle}>
      <Card.Body>
        <div className="qr-card-container">
          <div className="qr-scan-card">
            <div className={'qr-card-header'}>
              <textarea
                placeholder={`${t('unlock_pin_page.json_qr_code_payload')}`}
                disabled={disable}
                value={textAreaContent}
                onChange={handleTextAreaChange}
                style={QRCodeJsonPayloadTextArea}
              />
            </div>
            <div className="qr-card-footer">
              <button
                className="qr-scan-button"
                disabled={disable || textAreaContent.trim() === ''}
                type="button"
                onClick={handleSubmit}
              >
                <SendIcon /> {t('unlock_pin_page.get_pin')}
              </button>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}

export default QRCodeJsonUploadCard

const CardStyle: React.CSSProperties = {
  borderRadius: '20px',
  borderColor: '#C3C3C3',
  borderWidth: '1px',
}

const QRCodeJsonPayloadTextArea: React.CSSProperties = {
  width: '100%',
  height: '100%',
  resize: 'none',
  overflow: 'auto',
  borderRadius: '15px',
  borderWidth: '1px',
  padding: '10px',
  borderColor: '#666666',
}
